/**
 * このアプリは dev/stg を持たず、`sallyinc/app` の main を直接編集する。
 * 本番では「そういうアプリ」と自明なので、localhost で起動したときだけ警告を出す。
 */
const isLocalhost = () => {
  if (typeof window === 'undefined') return false;
  const { hostname } = window.location;
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1';
};

export const ProductionWarningBanner = () => {
  if (!isLocalhost()) return null;
  return (
    <div className="border-b border-red-300 bg-red-50">
      <div className="mx-auto max-w-6xl px-6 py-2 text-xs text-red-900">
        [localhost 起動中] ⚠️ このアプリは <code>sallyinc/app</code> の <code>main</code>{' '}
        ブランチを直接編集します (保存ボタンで翻訳者ブランチに commit、公開ボタンで main に PR +
        auto-merge)。 押し間違いに注意してください。
      </div>
    </div>
  );
};
